/*
 * Copyright © 2018-2026, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { ReactElement } from "react";
import { CurrencyDollar } from "../../common/Icons/CurrencyDollar";

interface Props {
  icon?: "money" | "list";
  title: string;
  value: any;
}

const StatInfoTile = ({ icon = "money", title, value }: Props): ReactElement => (
  <div className="tw-card p-5 flex">
    <div>
      <div className="font-semibold">{value}</div>
      <div>{title}</div>
    </div>
    <div className="ml-auto ">
      {icon === "money" ? (
        <CurrencyDollar className="h-10 text-sky-500" variant="outline" />
      ) : (
        <></>
      )}
    </div>
  </div>
);

export default StatInfoTile;
